module.exports = __webpack_public_path__ + "8d04611b1edb6efd0f6149a828fdd2a4.svg";